<script setup lang="ts">
import type { FormKitFrameworkContext } from '@formkit/core'
import TagsSelect from '../components/TagsSelect.vue'

const props = defineProps<{
  context: FormKitFrameworkContext
}>()
</script>
<template>
  <TagsSelect
    :options="context.attrs?.props?.options || []"
    :model-value="props.context.value"
    @update:model-value="context.node.input($event)"
  />
</template>
